import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h3>404 Error</h3>
        </div>
    );
};

export default NotFound;